import { render, staticRenderFns } from "./Presensi.vue?vue&type=template&id=2b2e58ab&scoped=true&lang=html&"
import script from "./Presensi.vue?vue&type=script&lang=js&"
export * from "./Presensi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2e58ab",
  null
  
)

export default component.exports